import { Confirm } from '@desygner/ui-common-components';
import React from 'react';
import ReactAppBuilder from 'src/utils/react-app-builder';

class ConfirmApp extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });
    this.labels = {};
    this.onConfirm = null;
    this.onCancel = null;
  }

  mountApp ({ labels, onConfirm, onCancel }) {
    this.labels = labels;
    this.onConfirm = onConfirm;
    this.onCancel = onCancel;
    super.mountApp(this.App);
  }

  closeApp () {
    this.labels = {};
    this.onConfirm = null;
    this.onCancel = null;
    super.closeApp(this.App);
  }

  handleConfirm (shouldNotAskAgain) {
    this.onConfirm?.(shouldNotAskAgain);
    this.closeApp();
  }

  handleCancel () {
    this.onCancel?.();
    this.closeApp();
  }

  App = () => {
    const props = {
      labels: this.labels,
      onConfirm: this.handleConfirm.bind(this),
      onCancel: this.handleCancel.bind(this)
    };

    return <Confirm {...props}/>;
  };
}

export default new ConfirmApp({
  appId: 'react-confirm-app',
  targetNodeSelector: 'body'
});
